<template>
  <div class="container page account-setting-page set-name-page">
    <van-nav-bar :title="$t('setting.modify_real_name')"  class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
      <template #right>
        <button class="nav-action" type="button" @click="save()">{{$t("setting.save")}}</button>
      </template>
    </van-nav-bar>
    <main class="setting-content">
      <div class="setting-hero">
        <div class="setting-hero-icon"><van-icon name="contact" /></div>
        <div>
          <div class="setting-kicker">Profile identity</div>
          <h1>{{$t('setting.modify_real_name')}}</h1>
          <p>Use the verified name associated with your Victoria membership.</p>
        </div>
      </div>
      <van-cell-group class="settings-form-card">
        <van-field v-model="name" left-icon="contact" :label="$t('setting.name')" :placeholder="$t('setting.name_place')" />
      </van-cell-group>
      <p class="setting-note"><van-icon name="info-o" /> {{$t("setting.name_tip")}}</p>
      <van-button class="settings-primary-button" type="primary" @click="save()">{{$t("setting.save")}}</van-button>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.userInfo.name){
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{name:this.name},
        url: 'user_set_name'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.page {
  background-color: #fff !important;
}
.van-cell {
  font-size: 0.37333rem;
  line-height: 0.8rem;
}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 0.37333rem;;
  color: #dc2037;
}
.van-cell-group {
  background-color: #fff;
  font-size: .37333rem;
  color: #000;
}
::v-deep .van-field__control{
  text-align: center !important;
}
.van-field__label {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 6.2em;
  margin-right: 1.6vw;
  color: #000;
  text-align: left;
  word-wrap: break-word;
}
.nav-bar{
  background-color: #fff !important;
}

::v-deep .van-nav-bar__title {
  color: #000 !important;
  font-size: 0.48rem !important;
  font-weight: 500 !important;
}

::v-deep .van-icon-arrow-left {
  color: #666 !important;
  font-size: 0.6rem !important;
}
</style>
